import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import { Formik } from "formik";
import { ValidationAddOnVehicle } from "../../utills/Validation";
import { Link } from "react-router-dom";
import {
  vehicleAddon,
  vehicleAddonDelete,
  vehicleAddonList,
} from "../../redux/action/vehicle";
import { useDispatch, connect, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { APIURL } from "../../redux/action/config";
import TableStatusRow from "../../components/loader/TableStatusRow";
const RentalAddOn = () => {
  const [id, setId] = useState();
  const dispatch = useDispatch();

  const [addOndata, setAddOndata] = useState("");
  useEffect(() => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/price`, requestOptions)
      .then((response) => response.json())
      .then((result) => setAddOndata(result?.data?.prices))
      .catch((error) => console.log("error", error));
  }, []);

  const vehiclelist = useSelector((state) => state?.vehicles?.list?.data);
  const [loading, setLoading] = React.useState(true);

  const loadList = async () => {
    setLoading(true);
    try {
      await dispatch(vehicleAddonList());
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadList();
  }, [dispatch]);

  const ReloadList = () => {
    loadList();
  };

  const funvehicleAddon = () => {
    loadList();
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/price`, requestOptions)
      .then((response) => response.json())
      .then((result) => setAddOndata(result?.data?.prices))
      .catch((error) => console.log("error", error));
  };
  const handleDeleteCat = (id) => {
    dispatch(vehicleAddonDelete(id, funvehicleAddon));
  };

  const ouantityMngmntStatus = (status) => {
    switch (status) {
      case true:
        return "Yes";
      case false:
        return "No";
      default:
        return "No";
    }
  };
  const [loadingBtn, setLoadingBtn] = useState(false);

  return (
    <Layout title="Add New Add On Item" page="rentalAddon">
      <ToastContainer autoClose={1500} />
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        <div id="kt_content_container" className="container-fluid">
          <div className="row">
            <div className="col-xl-8 offset-xl-2">
              <div className="card card-flush h-lg-100">
                <div className="card-header pt-7">
                  <div className="card-title">
                    <span className="svg-icon svg-icon-1 me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                          fill="black"
                        ></path>
                        <path
                          opacity="0.3"
                          d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                          fill="black"
                        ></path>
                      </svg>
                    </span>
                    <h2>Add New Add On Item:</h2>
                  </div>
                </div>
                <div className="card-body pt-5">
                  <Formik
                    initialValues={{
                      addName: "",
                      price: "",
                      isChecked: "",
                    }}
                    validationSchema={ValidationAddOnVehicle}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      const checkChildFun = (values) => {
                        if (values?.isChecked == "") {
                          return false;
                        }
                        return true;
                      };
                      const payload = {
                        ...values,
                        isChecked: checkChildFun(values),
                        // id: addOndata?._id,
                      };
                      setLoadingBtn(true);
                      dispatch(() => {
                        dispatch(
                          vehicleAddon(payload, (res) => {
                            if (res === "success") {
                              toast.success("Add on item Added Successfully!");
                              setTimeout(() => {
                                return (window.location.href =
                                  "/mange-rental-add-on");
                              }, 1000);
                            }
                            if (res === "error") {
                              setLoadingBtn(false);
                            }
                          })
                        );
                        dispatch(vehicleAddonList());
                        resetForm({ values: "" });
                        setSubmitting(false);
                      });
                    }}
                  >
                    {({
                      values,
                      handleBlur,
                      handleChange,
                      handleSubmit,
                      errors,
                      touched,
                    }) => (
                      <form className="form" onSubmit={handleSubmit}>
                        <div className="row mb-8">
                          <div className="col-xl-5">
                            <div className="fs-6 fw-bold mt-2 mb-3">
                              <span className="required">Name of new Add on:</span>
                            </div>
                          </div>
                          <div className="col-xl-7 fv-row fv-plugins-icon-container">
                            <input
                              type="text"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name="addName"
                              id="addName"
                              defaultValue={values.addName}
                              className="form-control form-control-solid"
                            />
                            {errors.addName && touched.addName ? (
                              <div className="text-danger mt-2">
                                {errors.addName}
                              </div>
                            ) : null}
                            <div className="fv-plugins-message-container invalid-feedback"></div>
                          </div>
                        </div>
                        <div className="row mb-8">
                          <div className="col-xl-5">
                            <div className="fs-6 fw-bold mt-2 mb-3"><span className="required">Price:</span></div>
                          </div>
                          <div className="col-xl-7 fv-row fv-plugins-icon-container">
                            <input
                              type="number"
                              step="any"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name="price"
                              id="price"
                              defaultValue={values.price}
                              className="form-control form-control-solid"
                            />

                            {errors.price && touched.price ? (
                              <div className="text-danger mt-2">
                                {errors.price}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="row mb-8">
                          <div className="col-xl-5">
                            <div className="fs-6 fw-bold mt-2 mb-3">
                              Quantity Management Required:
                            </div>
                          </div>
                          <div className="col-xl-7 fv-row fv-plugins-icon-container d-flex align-items-center">
                            <input
                              type="checkbox"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name="isChecked"
                              id="isChecked"
                              className="form-check-input custum-check mx-0 my-3 form-control p-0"
                            />

                            {/* {errors.isChecked && touched.isChecked ? (
                              <div className="text-danger mt-2">
                                {errors.isChecked}
                              </div>
                            ) : null} */}
                          </div>
                        </div>
                        <div className="separator mb-6"></div>
                        <div className="d-flex justify-content-end">
                          {/* <Link
                            to="/all-rentals"
                            type="reset"
                            className="btn btn-light me-3"
                          >
                            Cancel
                          </Link> */}
                          {!loadingBtn ? (
                            <button type="submit" className="btn btn-primary">
                              <span className="indicator-label">Add Now</span>
                            </button>
                          ) : (
                            <button
                              disabled={true}
                              className="btn btn-primary"
                              style={{ width: "60px" }}
                            >
                              <div
                                className="spinner-border text-dark"
                                style={{ height: "18px", width: "18px" }}
                                role="status"
                              >
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </button>
                          )}
                        </div>
                        <div></div>
                      </form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
            <div className="col-xl-8 offset-xl-2 pt-5 mt-5">
              <div className="col">
                <div className="card-title">
                  <h2>View All Add Ons:</h2>
                </div>
              </div>
              <table
                id="kt_datatable_example_5"
                className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer"
              >
                <>
                    <thead>
                      <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                        <th>Sr. No.</th>
                        <th>Add On Name</th>
                        <th>Quantity Management?</th>
                        <th>Price</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <TableStatusRow loading colSpan={5} />
                      ) : vehiclelist?.prices?.length > 0 ? (
                        vehiclelist?.prices?.map((items, ind) => {
                          return (
                            <tr className="pro-list-info" key={ind}>
                              <td>{ind + 1}</td>
                              <td>{items?.addName ? items?.addName : "N/A"}</td>
                              <td>
                                {items?.isChecked != null
                                  ? ouantityMngmntStatus(items?.isChecked)
                                  : "N/A"}
                              </td>
                              <td>
                                {items?.price
                                  ? items?.price
                                    ? `$${items?.price}`
                                    : ""
                                  : "N/A"}
                              </td>
                              <td>
                                <Link
                                  to={`/edit-addon/${items?._id}`}
                                  onClick={() => setId(items?._id)}
                                  className="btn btn-info action-hover"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-pencil-square"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                    <path
                                      fillRule="evenodd"
                                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                    />
                                  </svg>
                                </Link>
                                <button
                                  onClick={() => {
                                    handleDeleteCat(items?._id);
                                  }}
                                  className="btn btn-bg-dark"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-trash-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                  </svg>
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <TableStatusRow colSpan={5} />
                      )}
                      {/* <tr className="pro-list-info">
                              <td>1</td>
                              <td>1</td>
                              <td>1</td>
                              <td>1</td>
                              <td>
                                <Link
                                  to={`/edit-addon/${vehiclelist?.data?.prices?._id}`}
                                  onClick={() =>
                                    setId(vehiclelist?.data?.prices?._id)
                                  }
                                  className="btn btn-info action-hover"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-pencil-square"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                    <path
                                      fillRule="evenodd"
                                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                    />
                                  </svg>
                                </Link>
                                <button
                                  onClick={() => {
                                    handleDeleteCat(
                                      vehiclelist?.data?.prices?._id
                                    );
                                  }}
                                  className="btn btn-bg-dark"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-trash-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                  </svg>
                                </button>
                              </td>
                            </tr> */}
                    </tbody>
                  </>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default connect(null, {})(RentalAddOn);
